import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import nl from 'vuetify/lib/locale/nl'

Vue.use(Vuetify);


export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: '#eb5e0c',
        tertiary: '#089974',
      },
      light: {
        primary: '#eb5e0c',
        tertiary: '#089974',
      },
    },
  },
  lang: {
    locales: { nl },
    current: 'nl',
  },
});
